/*
 * @Author: Teemo Ding
 * @Date: 2021-06-07 09:24:49
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-05 14:04:20
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/salesChannel.ts
 */
/**
 *  SalesChannel  API data processing
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */
import { get, post, remove } from 'src/tools/server';
import { SalesChannel } from './types';

const getSalesChannels = (requestSourceID?: string) => {
  return get<SalesChannel[]>(`/portal/salesChannels`, {
    requestSourceID,
  });
};

const deleteSalesChannel = (salesChannelUuid) => {
  return remove<SalesChannel>(`/portal/salesChannel/${salesChannelUuid}`, {});
};

const createSalesChannel = (body: SalesChannel): Promise<SalesChannel> => {
  return post<SalesChannel>(`/portal/salesChannel`, body, {});
};

const salesChannelRename = (body): Promise<SalesChannel> => {
  return post<SalesChannel>(`/portal/salesChannel/rename`, body, {});
};

const duplicateSalesChannel = (body): Promise<SalesChannel> => {
  return post<SalesChannel>(`/portal/salesChannel/duplicate`, body, {});
};

const getSalesChannel = (salesChannelUuid): Promise<SalesChannel> => {
  return get<SalesChannel>(`/portal/salesChannel/${salesChannelUuid}`, {});
};

const getSalesChannelVersion = (salesChannelUuid): Promise<any[]> => {
  return get<any[]>(`/portal/salesChannelContents/${salesChannelUuid}`, {});
};
const getSalesChannelEditList = () => {
  return get<any>(`/portal/salesChannel/editPage`, {});
};

export {
  getSalesChannels,
  deleteSalesChannel,
  createSalesChannel,
  salesChannelRename,
  getSalesChannel,
  duplicateSalesChannel,
  getSalesChannelEditList,
  getSalesChannelVersion,
};
